import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { StyledLoader, StyledLoaderStage, StyledLoaderLine } from './style';


export const Loader = ({ isBlack, isOverlay, outlineStyle, isFullScreen }) => {

  useEffect(() => {
    if (isFullScreen) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      if (isFullScreen) {
        document.body.style.overflow = 'scroll'
      }
    }
  }, [isFullScreen])

  return (
    <StyledLoader isFullScreen={isFullScreen} isBlack={isBlack} isOverlay={isOverlay}>
      <StyledLoaderStage>
        <StyledLoaderLine isBlack={isBlack} />
      </StyledLoaderStage>
    </StyledLoader>
  );
};

Loader.propTypes = {
  isBlack: PropTypes.bool,
  isOverlay: PropTypes.bool,
};

Loader.defaultProps = {
  isBlack: true,
  isOverlay: false,
};
